import { ViewLoader } from '@ui/utils';
import {
  MRT_ColumnFiltersState,
  MRT_PaginationState,
  MRT_SortingState,
} from 'material-react-table';
import { ComponentType, useState } from 'react';
import { useDidUpdateEffect } from '../../hooks/useDidUpdateEffect';
import { useReportCtx } from '../report-ctx';
import { ListingType } from '../types';
import { ListingResultProps } from './ListingView';

export function ListingViewResult<R extends ListingType>(p: {
  Result: ComponentType<ListingResultProps<R>>;
  showEmpty?: boolean;
}) {
  const { Result, showEmpty } = p;

  const ctx = useReportCtx<ListingType>();

  const [sorting, setSorting] = useState<MRT_SortingState>([]);
  const [columnFilters, setColumnFilters] = useState<MRT_ColumnFiltersState>([]);
  const [pagination, setPagination] = useState<MRT_PaginationState>({
    pageIndex: ctx.values.pageIndex || 0,
    pageSize: ctx.values.pageSize || 50,
  });

  useDidUpdateEffect(() => {
    ctx.runReport({
      ...ctx.values,
      pageIndex: pagination.pageIndex,
      pageSize: pagination.pageSize,
    });
  }, [pagination.pageIndex, pagination.pageSize]);

  useDidUpdateEffect(() => {
    const sortValue = sorting[0]
      ? `${sorting[0].id} ${sorting[0].desc ? 'desc' : 'asc'}`
      : undefined;

    ctx.runReport({
      ...ctx.values,
      sort: sortValue,
    });
  }, [sorting[0]]);

  useDidUpdateEffect(() => {
    ctx.runReport({
      ...ctx.values,
      filters: columnFilters,
    });
  }, [columnFilters]);

  if (!ctx.result && !showEmpty) {
    return <ViewLoader />;
  }

  return (
    <Result
      mrtProps={{
        manualSorting: true,
        onSortingChange: setSorting,
        manualPagination: true,
        onPaginationChange: setPagination,
        manualFiltering: true,
        onColumnFiltersChange: setColumnFilters,
        rowCount: ctx.result ? ctx.result.metadata.totalCount : undefined,
        data: ctx.result ? ctx.result.results : [],
        state: {
          pagination: pagination,
          sorting: sorting,
          columnFilters: columnFilters,
          showProgressBars: ctx.isLoading,
        },
      }}
    />
  );
}
